import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { adminRoutes } from './Data'
import AdminNavigation from '../components/navigation/AdminNavigation'
import Error404 from '../components/error/Error404'
import { useAuth } from '../context/AuthContext'
import { routesFor } from '../utils/integrityReviewer'

const AdminRoutes = () => {
    const { user } = useAuth();

    // A reviewer-only path does not exist for anyone else: it falls through to the
    // catch-all below and lands on the dashboard.
    return (
        <Routes>
            <Route element={<AdminNavigation />}>
                {routesFor(adminRoutes, user).map(({ path, element }, index) => (
                    <Route key={index} path={path} element={element} />
                ))}
                <Route path="*" element={<Navigate to="/dashboard/data" />} />
            </Route>
        </Routes>
    )
}

export default AdminRoutes